import { render, staticRenderFns } from "./table-series.vue?vue&type=template&id=f55cb326&scoped=true&"
import script from "./table-series.vue?vue&type=script&lang=js&"
export * from "./table-series.vue?vue&type=script&lang=js&"
import style0 from "./table-series.vue?vue&type=style&index=0&id=f55cb326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55cb326",
  null
  
)

export default component.exports